import { Link } from 'react-router-dom';

import { EventType } from '../../../../types/events/common.types';

import { getRouteForEventType } from 'routes/referral/hooks/useEventTypeRedirect';

import eventBg from 'assets/single-event/event_bg.png';

import { AnalyticsBadge } from './AnalyticsBadge';

type AnalyticsEventItemProps = {
  id: number;
  name: string;
  imageUrl: string | null;
  isVip?: boolean;
  isUpcoming?: boolean;
  eventType: EventType;
};

export const AnalyticsEventItem = ({
  id,
  name,
  imageUrl,
  isVip = false,
  isUpcoming = false,
  eventType,
}: AnalyticsEventItemProps) => {
  const link = getRouteForEventType(eventType, id.toString());

  return (
    <Link
      to={link}
      className="tw-relative tw-block tw-h-[170px] tw-w-[280px] tw-overflow-hidden tw-rounded-[10px] tw-bg-analyticsEventsGradient tw-p-[1px] tw-no-underline tw-transition-transform hover:tw-scale-105"
    >
      <img src={imageUrl || eventBg} alt={name} className="tw-h-full tw-w-full tw-rounded-[10px] tw-object-cover" />
      <div className="tw-absolute tw-right-[8px] tw-top-[8px] tw-flex tw-items-center tw-justify-center tw-gap-[8px]">
        {isVip && <AnalyticsBadge text="vip" color="tw-bg-[#20AA67]" />}
        {isUpcoming && <AnalyticsBadge text="upcoming" color="tw-bg-[#2D5EFF]" />}
      </div>

      {/* <p className="tw-absolute tw-bottom-[16px] tw-w-full tw-text-center tw-text-[16px] tw-text-[20px] tw-font-bold tw-uppercase tw-text-white">
        {name}
      </p> */}
    </Link>
  );
};
